import { useQuery, useMutation } from '@tanstack/react-query';
import { orpc } from './client';

/**
 * Hook to list all feature flags from backend
 */
export function useListFeatureFlags() {
  return useQuery(orpc.testing.featureFlags.list.queryOptions({ input: {} }));
}

/**
 * Hook to set feature flag override in backend
 */
export function useSetFeatureFlagOverride() {
  return useMutation(orpc.testing.featureFlags.set.mutationOptions());
}

/**
 * Hook to remove feature flag override in backend
 */
export function useRemoveFeatureFlagOverride() {
  return useMutation(orpc.testing.featureFlags.remove.mutationOptions());
}

/**
 * Hook to clear all feature flag overrides in backend
 */
export function useClearAllFeatureFlagOverrides() {
  return useMutation(orpc.testing.featureFlags.clearAll.mutationOptions());
}
